






































































































































import { ClientAccount } from '@/shared/clients/client-account';
import { ClientAccountFactFind, createClientAccountFactFind } from '@/shared/clients/client-account-fact-find';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';


@Component
export default class AddFactFindDialog extends Vue {
    @Prop({ required: true }) public client!: ClientAccount;
    @Prop({ required: true }) public visible!: boolean;

    private isVisible: boolean = this.visible;
    private saving: boolean = false;
    private factFind: ClientAccountFactFind = createClientAccountFactFind();

    @Watch('visible')
    private onVisibleChanged(visible: boolean): void {
        this.factFind = createClientAccountFactFind();
        this.isVisible = visible;
    }
    private onCancel(): void {
        this.$emit('cancel');
    }
    private async onSave(): Promise<void> {
        this.saving = true;

        try {
            this.$emit('ok', { ...this.factFind });
        } catch (e) {
            this.$snackbar.open({ message: `Could not create new fact find, please try again.`, type: 'is-danger' });
        }
    }
}
